import { t } from 'i18next';
import { type Id, toast, type ToastOptions } from 'react-toastify';

import api from '../api';

const toastMeta: { id: null | Id } = { id: null };

export function errorToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast.error(t(msg), options);
}

export function successToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast.success(t(msg), options);
}

export function infoToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast(t(msg), options);
}

export function warningToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast.warning(t(msg), options);
}

export async function waferSaveToast(
  waferId: number,
  onSave: () => void,
  onDiscard: () => void
) {
  dismissAllToast();

  let resolved = false;
  const resolve = (action: 'save' | 'discard') => {
    if (resolved) {
      return;
    }
    resolved = true;
    if (action === 'save') {
      onSave();
    } else {
      onDiscard();
    }
  };

  const waferName: string = await api
    .getWaferImage('', waferId)
    .then(data => data.organization_wafer_id);

  toastMeta.id = toast(
    ({ closeToast }: { closeToast?: () => void }) => {
      let counter = 7;
      const interval = setInterval(() => {
        counter--;
        if (counter === 0) {
          clearInterval(interval);
        }
        const timerSpan = document.getElementById('save-timer-12ssqq12');
        if (timerSpan) {
          timerSpan.innerText = counter.toString();
        }
      }, 1000);

      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <span>
            <strong>Saving labels for Wafer {waferName}</strong>
            <br />
            Labels will save in <span id='save-timer-12ssqq12'>7</span>s unless
            you discard.
          </span>
          <button
            onClick={() => {
              resolve('discard');
              closeToast?.();
            }}
            style={{
              backgroundColor: '#ff7373ff',
              color: '#fff',
              border: 'none',
              padding: 4,
              borderRadius: 4,
              fontSize: 12,
              cursor: 'pointer',
              width: 'fit-content',
              alignSelf: 'flex-end',
            }}
          >
            Discard
          </button>
        </div>
      );
    },
    {
      autoClose: 7000,
      closeOnClick: false,
      onClose: () => resolve('save'),
    }
  );
}

function dismissAllToast() {
  if (toastMeta.id) {
    toast.clearWaitingQueue();
    toast.dismiss(toastMeta.id);
  }
}
